import { render, staticRenderFns } from "./InOtherCall.vue?vue&type=template&id=74c7b56a"
import script from "./InOtherCall.vue?vue&type=script&lang=js"
export * from "./InOtherCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports